module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "calibre11",
    attrs: {
      "id": "pgepubid00006"
    }
  }, [_c('a', {
    attrs: {
      "id": "I._JOHN_DRYDEN"
    }
  }, [_vm._v("I. JOHN DRYDEN")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_vm._v("If the prospect of delight be wanting (which alone justifies the perusal\nof poetry) we may let the reputation of Dryden sleep in the manuals of\nliterature. To those who are genuinely insensible of his genius (and\nthese are probably the majority of living readers of poetry) we can only\noppose illustrations of the following proposition: that their\ninsensibility does not merely signify indifference to satire and wit,\nbut lack of perception of qualities not confined to satire and wit and\npresent in the work of other poets whom these persons feel that they\nunderstand. To those whose taste in poetry is formed entirely upon the\nEnglish poetry of the nineteenth-century—to the majority—it is\ndifficult to explain or excuse Dryden: the twentieth century is still\nthe nineteenth, although it may in time acquire its own character. The\nnineteenth century had, like every other, limited tastes and peculiar\nfashions; and, like every other, it was unaware of its own limitations.\nIts tastes and fashions had no place for Dryden; yet Dryden is one of\nthe tests of a catholic appreciation of poetry.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_vm._v("He is a successor of Jonson, and therefore the descendant of Marlowe; he\nis the ancestor of nearly all that is best in the poetry of the\neighteenth century. Once we have mastered Dryden—and by mastery is\nmeant a full and essential enjoyment, not the enjoyment of a private\nwhimsical fashion—we can extract whatever enjoyment and edification\nthere is in his contemporaries—Oldham, Denham, or the less\nremunerative Waller; and still more his successors—not only Pope, but\nPhillips, Churchill, Gray, Johnson, Cowper, Goldsmith. His inspiration is\nprolonged in Crabbe and Byron; it even extends, as Mr. van Doren\ncleverly points out, to Poe. Even the poets responsible for the revolt\nwere well acquainted with him: Wordsworth knew his work, and Keats\ninvoked his aid. We cannot fully enjoy or rightly estimate a hundred\nyears of English poetry unless we fully enjoy Dryden; and to enjoy\nDryden means to pass beyond the limitations of the nineteenth century\ninto a new freedom.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_c('span', {
    staticClass: "calibre16"
  }, [_vm._v("All, all of a piece throughout!")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Thy Chase had a Beast in View;")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Thy Wars brought nothing about;")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Thy Lovers were all untrue.")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("'Tis well an Old Age is out,")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("And time to begin a New.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_c('span', {
    staticClass: "calibre17"
  }, [_vm._v("* * * *")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_c('span', {
    staticClass: "calibre16"
  }, [_vm._v("The world's great age begins anew,")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("The golden years return,")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("The earth doth like a snake renew")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Her winter weeds outworn:")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Heaven smiles, and faiths and empires gleam")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Like wrecks of a dissolving dream.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_vm._v("The first of these passages is by Dryden, the second by Shelley; the\nsecond is found in the \"Oxford Book of English Verse,\" the first is not;\nyet we might defy anyone to show that the second is superior on\nintrinsically poetic merit. It is easy to see why the second should\nappeal more readily to the nineteenth, and what is left of the\nnineteenth under the name of the twentieth, century. It is not so easy\nto see propriety in an image which divests a snake of \"winter weeds\";\nand this is a sort of blemish which would have been noticed more quickly\nby a contemporary of Dryden than by a contemporary of Shelley.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_vm._v("These reflections are occasioned by an admirable book on Dryden which\nhas appeared at this very turn of time, when taste is becoming perhaps\nmore fluid and ready for a new mould."), _c('a', {
    attrs: {
      "id": "FNanchor_1_1"
    }
  }), _c('a', {
    staticClass: "fnanchor",
    attrs: {
      "href": "#/Text/Section0004#Footnote_1_1"
    }
  }, [_vm._v("[1]")]), _vm._v(" It is a book which every\npractitioner of English verse should study. The consideration is so\nthorough, the matter so compact, the appreciation so just, temperate,\nand enthusiastic, and supplied with such copious and well-chosen\nextracts from the poetry, the suggestion of astutely placed facts leads\nour thought so far, that there only remain to mention, as defects which\ndo not detract from its value, two omissions: the prose is not dealt\nwith, and the plays are somewhat slighted. What is especially impressive\nis the exhibition of the very wide range of Dryden's work, shown by the\nquotations of every species. Everyone knows \"MacFlecknoe,\" and parts of\n\"Absalom and Achitophel\"; in consequence, Dryden has sunk by the persons\nhe has elevated to distinction—Shadwell of Settle, Shaftesbury and\nBuckingham. Dryden was much more than a satirist; to dispose of him as a\nsatirist is to place an obstacle in the way of our understanding. At all\nevents, we must satisfy ourselves of our definition of the term satire;\nwe must not allow our familiarity with the word to blind us to\ndifferences and refinements; we must not assume that satire is a fixed\ntype, and fixed to the prosaic, suited only to prose; we must\nacknowledge that satire is not the same thing in the hands of two\ndifferent writers of genius. The connotations of \"satire\" and of \"wit,\"\nin short, may be only prejudices of nineteenth-century taste. Perhaps,\nwe think, after reading Mr. van Doren's book, a juster view of Dryden\nmay be given by beginning with some other portion of his work than his\ncelebrated satires; but even here there is much more present, and much\nmore that is poetry, than is usually supposed.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_vm._v("The piece of Dryden's which is the most fun, which is the most sustained\ndisplay of surprise after surprise of wit from line to line, is\n\"MacFlecknoe.\" Dryden's method here is something very near to parody; he\napplies vocabulary, images, and ceremony which arouse epic associations\nof grandeur, to make an enemy helplessly ridiculous. But the effect,\nthough disastrous for the enemy, is very different from that of the\nhumour which merely belittles, such as the satire of Mark Twain. Dryden\ncontinually enhances: he makes his object great, in a way contrary to\nexpectation; and the total effect is due to the transformation of the\nridiculous into poetry. As an example may be taken a fine passage\nplagiarized from Cowley, from lines which Dryden must have marked well,\nfor he quotes them directly in one of his prefaces. Here is Cowley:—")]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Where their vast courts the mother-waters keep,")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("And undisturbed by moons in silence sleep. . . .")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Beneath the dens where unfledged tempests lie,")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("And infant winds their tender voices try.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_vm._v("In \"MacFlecknoe\" this becomes:—")]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Where their vast courts the mother-strumpets keep,")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("And undisturbed by watch, in silence sleep.")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Near these, a nursery erects its head,")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Where queens are formed, and future heroes bred;")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Where unfledged actors learn to laugh and cry,")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Where infant punks their tender voices try,")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("And little Maximins the gods defy.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_vm._v("The passage from Cowley is by no means despicable verse. But it is a\ncommonplace description of commonly poetic objects; it has not the\nelement of "), _c('i', {
    staticClass: "calibre18"
  }, [_vm._v("surprise")]), _vm._v(" so essential to poetry, and this Dryden\nprovides. A clever versifier might have written Cowley's lines; only a\npoet could have made what Dryden made of them. It is impossible to\ndismiss his verses as \"prosaic\"; turn them into prose and they are\ntransmuted, the fragrance is gone. The reproach of the prosaic, levelled\nat Dryden, rests upon a confusion between the emotions considered to be\npoetic—which is a matter allowing considerable latitude of\nfashion—and the "), _c('i', {
    staticClass: "calibre18"
  }, [_vm._v("result")]), _vm._v(" of personal emotion in poetry; and,\nin the third place, there is the emotion "), _c('i', {
    staticClass: "calibre18"
  }, [_vm._v("depicted")]), _vm._v(" by the poet in\nsome kinds of poetry, of which the \"Testaments\" of Villon is an example.\nAgain, there is the intellect, the originality and independence and\nclarity of what we vaguely call the poet's \"point of view.\" Our\nvaluation of poetry, in short, depends upon several considerations, upon\nthe permanent and upon the mutable and upon the transitory. When we try\nto isolate the essentially poetic, we bring our pursuit in the end to\nsomething insignificant; our standards vary with every poet whom we\nconsider. All we can hope to do, in the attempt to introduce some order\ninto our preferences, is to clarify our reasons for finding pleasure in\nthe poetry that we like.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_vm._v("With regard to Dryden, therefore, we can say this much. Our taste in\nEnglish poetry has been largely founded upon a partial perception of the\nvalue of Shakespeare and Milton, a perception which dwells upon\nsublimity of theme and action. Shakespeare had a great deal more; he had\nnearly everything to satisfy our various desires for poetry. The point\nis that the depreciation or neglect of Dryden is not due to the fact\nthat his work is not poetry, but to a prejudice that the material, the\nfeelings, out of which he built is not poetic. Thus Matthew Arnold\nobserves, in mentioning Dryden and Pope together, that \"their poetry is\nconceived and composed in their wits, genuine poetry is conceived in the\nsoul.\" Arnold was, perhaps, not altogether the detached critic when he\nwrote this line; he may have been stirred to a defence of his own\npoetry, conceived and composed in the soul of a mid-century Oxford\ngraduate. Pater remarks that Dryden—")]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre19"
  }, [_c('div', {
    staticClass: "calibre20"
  }, [_c('p', {
    staticClass: "calibre14"
  }, [_vm._v("\"Loved to emphasize the distinction between poetry and prose, the\nprotest against their confusion coming with somewhat diminished effect\nfrom one whose poetry was so prosaic.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_vm._v("But Dryden was right, and the sentence of Pater is cheap journalism.\nHazlitt, who had perhaps the most uninteresting mind of all our\ndistinguished critics, says—")]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_vm._v("\"Dryden and Pope are the great masters of the artificial style of poetry\nin our language, as the poets of whom I have already treated—Chaucer,\nSpenser, Shakespeare, and Milton—were of the natural.\"")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_vm._v("In one sentence Hazlitt has committed at least four crimes against\ntaste. It is bad enough to lump Chaucer, Spenser, Shakespeare, and\nMilton together under the denomination of \"natural\"; it is bad to commit\nShakespeare to one style only; it is bad to join Dryden and Pope\ntogether; but the last absurdity is the contrast, of Milton, our\ngreatest master of the "), _c('i', {
    staticClass: "calibre18"
  }, [_vm._v("artificial")]), _vm._v(" style, with Dryden, whose style\n(vocabulary, syntax, and order of thought) is in a high degree natural.\nAnd what all these objections come to, we repeat, is a repugnance for\nthe material out of which Dryden's poetry is built.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_vm._v("It would be truer to say, indeed, even in the form of the unpersuasive\nparadox, that Dryden is distinguished principally by his poetic ability.\nWe prize him, as we do Mallarmé, for what he made of his material. Our\nestimate is only in part the appreciation of ingenuity: in the end the\nresult is poetry. Much of Dryden's unique merit consists in his ability\nto make the small into the great, the prosaic into the poetic, the\ntrivial into the magnificent. In this he differs not only from Milton,\nwho required a canvas of the largest size, but from Pope, who required\none of the smallest. If you compare any satiric \"character\" of Pope with\none of Dryden, you will see that the method and intention are widely\ndivergent. When Pope alters, he diminishes; he is a master of miniature.\nThe singular skill of his portrait of Addison, for example, in the\n\"Epistle to Arbuthnot,\" depends upon the justice and reserve, the\napparent determination not to exaggerate. The genius of Pope is not for\ncaricature. But the effect of the portraits of Dryden is to transform\nthe object into something greater, as were transformed the verses of\nCowley quoted above.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_c('span', {
    staticClass: "calibre16"
  }, [_vm._v("A fiery soul, which working out its way,")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Fretted the pigmy body to decay:")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("And o'er informed the tenement of clay.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_vm._v("These lines are not merely a magnificent tribute. They create the object\nwhich they contemplate; the poetry is purer than anything in Pope except\nthe last lines of the \"Dunciad.\" Dryden is in fact much nearer to the\nmaster of comic creation than to Pope. As in Jonson, the effect is far\nfrom laughter; the comic is the material, the result is poetry. The\nCivic Guards of Rhodes—")]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_c('span', {
    staticClass: "calibre16"
  }, [_vm._v("The country rings around with loud alarms,")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("And raw in fields the rude militia swarms;")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Mouths without hands; maintained at vast expense,")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("In peace a charge, in war a weak defence;")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Stout once a month they march, a blust'ring band,")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("And ever, but in times of need, at hand;")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("This was the morn, when issuing on the guard,")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Drawn up in rank and file they stood prepared")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Of seeming arms to make a short essay,")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Then hasten to be drunk, the business of the day.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_vm._v("Sometimes the wit appears as a delicate flavour to the magnificence,\nas in \"Alexander's Feast\":—")]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Sooth'd with the sound the king grew vain;")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Fought all his battles o'er again;")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("And thrice he routed all his foes, and thrice he slew the slain.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_vm._v("The great advantage of Dryden over Milton is that while the former is\nalways in control of his ascent, and can rise or fall at will (and how\nmasterfully, like his own Timotheus, he directs the transitions!), the\nlatter has elected a perch from which he cannot afford to fall, and from\nwhich he is in danger of slipping.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_c('span', {
    staticClass: "calibre21"
  }, [_vm._v("food alike those pure")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Intelligential substances require")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("As doth your Rational; and both contain")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Within them every lower faculty")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Of sense, whereby they hear, see, smell, touch, taste,")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Tasting concoct, digest, assimilate,")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("And corporeal to incorporeal turn.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_vm._v("Dryden might have made poetry out of that; his translation from\nLucretius is poetry. But we have an ingenious example, on which to test\nour contrast of Dryden and Milton: it is Dryden's \"Opera,\" called "), _c('i', {
    staticClass: "calibre18"
  }, [_vm._v("The\nState of Innocence and Fall of Man")]), _vm._v(", of which Nathaniel Lee neatly says\nin his preface:—")]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Milton did the wealthy mine disclose,")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("And rudely cast what you could well dispose:")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("He roughly drew, on an old-fashioned ground,")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("A chaos, for no perfect world were found,")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Till through the heap, your mighty genius shined.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_vm._v("In the author's preface Dryden acknowledges his debt generously\nenough:—")]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_vm._v("\"The original being undoubtedly, one of the greatest, most\nnoble, and most sublime poems, which either this age or nation\nhas produced.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_vm._v("The poem begins auspiciously:—")]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_c('i', {
    staticClass: "calibre18"
  }, [_vm._v("Lucifer")]), _vm._v(":"), _c('span', {
    staticClass: "calibre22"
  }, [_vm._v("Is this the seat our conqueror has given?")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre23"
  }, [_vm._v("And this the climate we must change for Heaven?")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre23"
  }, [_vm._v("These regions and this realm my wars have got;")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre23"
  }, [_vm._v("This mournful empire is the loser's lot:")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre23"
  }, [_vm._v("In liquid burnings, or on dry to dwell,")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre23"
  }, [_vm._v("Is all the sad variety of hell.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_vm._v("It is an early work; it is on the whole a feeble work; it is not\ndeserving of sustained comparison with \"Paradise Lost.\" But \"all the sad\nvariety of hell\"! Dryden is already stirring; he has assimilated what he\ncould from Milton; and he has shown himself capable of producing as\nsplendid verse.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_vm._v("The capacity for assimilation, and the consequent extent of range, are\nconspicuous qualities of Dryden. He advanced and exhibited his variety\nby constant translation; and his translations of Horace, of Ovid, of\nLucretius, are admirable. His gravest defects are supposed to be\ndisplayed in his dramas, but if these were more read they might be more\npraised. From the point of view of either the Elizabethan or the French\ndrama they are obviously inferior; but the charge of inferiority loses\npart of its force if we admit that Dryden was not quite trying to\ncompete with either, but was pursuing a direction of his own. He created\nno character; and although his arrangements of plot manifest exceptional\ningenuity, it is the pure magnificence of diction, of poetic diction,\nthat keeps his plays alive:—")]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_c('span', {
    staticClass: "calibre24"
  }, [_vm._v("How I loved")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Witness ye days and nights, and all ye hours,")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("That danced away with down upon your feet,")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("As all your business were to count my passion.")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("One day passed by, and nothing saw but love;—")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Another came, and still 'twas only love:")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("The suns were wearied out with looking on,")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("And I untired with loving.")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("I saw you every day and all the day;")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("And every day was still but as the first:")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("So eager was I still to see you more . . .")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre25"
  }, [_vm._v("While within your arms I lay,")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("The world fell mould'ring from my hands each hour.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_vm._v("Such language is pure Dryden: it sounds, in Mr. van Doren's phrase,\n\"like a gong.\" "), _c('i', {
    staticClass: "calibre18"
  }, [_vm._v("All for Love")]), _vm._v(", from which the lines are taken, is\nDryden's best play, and this is perhaps the highest reach. In general,\nhe is best in his plays when dealing with situations which do not demand\ngreat emotional concentration; when his situation is more trivial, and\nhe can practise his art of making the small great. The back-talk between\nthe Emperor and his Empress Nourmahal, in "), _c('i', {
    staticClass: "calibre18"
  }, [_vm._v("Aurungzebe")]), _vm._v(" is admirable\npurple comedy:—")]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_c('i', {
    staticClass: "calibre18"
  }, [_vm._v("Emperor")]), _vm._v(":"), _c('span', {
    staticClass: "calibre22"
  }, [_vm._v("Such virtue is the plague of human life:")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre26"
  }, [_vm._v("A virtuous woman, but a cursed wife.")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre26"
  }, [_vm._v("In vain of pompous chastity y'are proud:")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre26"
  }, [_vm._v("Virtue's adultery of the tongue, when loud.")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre26"
  }, [_vm._v("I, with less pain, a prostitute could bear,")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre26"
  }, [_vm._v("Than the shrill sound of virtue, virtue hear.")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre26"
  }, [_vm._v("In unchaste wives—")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre26"
  }, [_vm._v("There's yet a kind of recompensing ease:")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre26"
  }, [_vm._v("Vice keeps 'em humble, gives 'em care to please:")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre26"
  }, [_vm._v("But against clamourous virtue, what defence?")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre26"
  }, [_vm._v("It stops our mouths, and gives your noise pretence. . .")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre26"
  }, [_vm._v("What can be sweeter than our native home?")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre26"
  }, [_vm._v("Thither for ease, and soft repose, we come;")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre26"
  }, [_vm._v("Home is the sacred refuge of our life:")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre26"
  }, [_vm._v("Secure from all approaches but a wife.")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre26"
  }, [_vm._v("If thence we fly, the cause admits no doubt:")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre26"
  }, [_vm._v("None but an inmate foe could force us out.")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre26"
  }, [_vm._v("Clamours, our privacies uneasy make:")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre26"
  }, [_vm._v("Birds leave their nests disturbed, and beasts their haunts")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre17"
  }, [_vm._v("forsake.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_vm._v("But drama is a mixed form; pure magnificence will not carry it through.\nThe poet who attempts to achieve a play by the single force of the word\nprovokes comparison, however strictly he confine himself to his\ncapacity, with poets of other gifts. Corneille and Racine do not attain\ntheir triumphs by magnificence of this sort; they have concentration\nalso, and, in the midst of their phrases, an undisturbed attention to\nthe human soul as they knew it.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_vm._v("Nor is Dryden unchallenged in his supreme ability to make the\nridiculous, or the trivial, great.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Avez-vous observé que maints cercueils de vieilles")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Sont presque aussi petits que celui d'un enfant?")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_vm._v("Those lines are the work of a man whose verse is as magnificent as\nDryden's, and who could see profounder possibilities in wit, and in\nviolently joined images, than ever were in Dryden's mind. For Dryden,\nwith all his intellect, had a commonplace mind. His powers were, we\nbelieve, wider, but no greater, than Milton's; he was confined by\nboundaries as impassable, though less strait. He bears a curious\nantithetical resemblance to Swinburne. Swinburne was also a master of\nwords, but Swinburne's words are all suggestions and no denotation; if\nthey suggest nothing, it is because they suggest too much. Dryden's\nwords, on the other hand, are precise, they state immensely, but their\nsuggestiveness is almost nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_c('span', {
    staticClass: "calibre16"
  }, [_vm._v("That short dark passage to a future state;")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("That melancholy riddle of a breath,")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("That something, or that nothing, after death.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_vm._v("is a riddle, but not melancholy enough, in Dryden's splendid verse. The\nquestion, which has certainly been waiting, may justly be asked:\nwhether, without this which Dryden lacks, verse can be poetry? What is\nman to decide what poetry is? Dryden's use of language is not, like that\nof Swinburne, weakening and demoralizing. Let us take as a final test\nhis elegy upon Oldham, which deserves not to be mutilated:—")]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Farewell, too little and too lately known,")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Whom I began to think and call my own;")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("For sure our souls were near allied, and thine")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Cast in the same poetic mould with mine.")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("One common note on either lyre did strike,")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("And knaves and fools we both abhorred alike.")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("To the same goal did both our studies drive;")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("The last set out the soonest did arrive.")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Thus Nisus fell upon the slippery place,")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Whilst his young friend performed and won the race.")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("O early ripe! to thy abundant store")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("What could advancing age have added more?")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("It might (what nature never gives the young)")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Have taught the numbers of thy native tongue.")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("But satire needs not those, and wit will shine")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Through the harsh cadence of a rugged line.")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("A noble error, and but seldom made,")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("When poets are by too much force betrayed.")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Thy generous fruits, though gathered ere their prime,")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Still showed a quickness; and maturing time")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("But mellows what we write to the dull sweets of rhyme.")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Once more, hail, and farewell; farewell, thou young,")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("But ah! too short, Marcellus of our tongue!")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("Thy brows with ivy and with laurels bound;")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre16"
  }, [_vm._v("But fate and gloomy night encompass thee around.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_vm._v("From the perfection of such an elegy we cannot detract; the lack of\nnebula is compensated by the satisfying completeness of the statement.\nDryden lacked what his master Jonson possessed, a large and unique view\nof life; he lacked insight, he lacked profundity. But where Dryden fails\nto satisfy, the nineteenth-century does not satisfy us either; and where\nthat century has condemned him, it is itself condemned. In the next\nrevolution of taste it is possible that poets may turn to the study of\nDryden. He remains one of those who have set standards for English verse\nwhich, it is desperate to ignore.")]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "calibre14"
  }, [_c('a', {
    attrs: {
      "id": "Footnote_1_1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Text/Section0004#FNanchor_1_1"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[1]")])]), _vm._v("\"John Dryden,\" by Mark van Doren (New York: Harcourt,\nBrace and Howe).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5ff7c0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0004.vue
// module id = 66
// module chunks = 0